/* Shufooni — commerce layer behaviour: jump to Judge.me reviews, buy-together bundle, cart smart bundle (vanilla, no deps) */
(function () {
  'use strict';
  if (window.__shfCommerce) return;
  window.__shfCommerce = 1;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, data) {
    data = data || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      else if (window.dataLayer && window.dataLayer.push) { var o = { event: name }; for (var k in data) o[k] = data[k]; window.dataLayer.push(o); }
    } catch (e) {}
  }
  function fmt(cents) {
    var v = Math.round(cents) / 100;
    return '₪' + (v % 1 ? v.toFixed(2) : String(v));
  }
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function onCartPage() {
    return document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname);
  }
  function refreshCart() {
    if (onCartPage()) { location.reload(); return Promise.resolve(); }
    var Cart = window.spratlyTheme && window.spratlyTheme.Cart;
    if (Cart && typeof Cart.refreshCart === 'function') {
      return Promise.resolve(Cart.refreshCart())
        .then(function () { return typeof Cart.renderNewCart === 'function' ? Cart.renderNewCart() : null; })
        .then(function () {
          /* the header / sticky cart badges are only updated by the theme's own add flow */
          try { if (typeof Cart.updateCartCount === 'function' && Cart.cart) Cart.updateCartCount(Cart.cart); } catch (e) {}
        })
        .then(function () { if (typeof Cart.openCartDrawer === 'function') Cart.openCartDrawer(); });
    }
    location.href = root + 'cart';
    return Promise.resolve();
  }
  function settle(btn, ok) {
    btn.classList.remove('shf-is-busy');
    if (ok) {
      btn.classList.add('shf-is-done');
      setTimeout(function () { btn.classList.remove('shf-is-done'); }, 1800);
    }
  }

  function addItems(btn, items) {
    if (!items.length || btn.classList.contains('shf-is-busy')) return;
    btn.classList.add('shf-is-busy');
    var evt = btn.getAttribute('data-shf-evt') || 'add';
    post('cart/add.js', { items: items })
      .then(function () {
        track('shf_bundle_add', { type: evt, items: items.length });
        settle(btn, true);
        return refreshCart();
      })
      .catch(function () { settle(btn, false); location.href = root + 'cart'; });
  }

  /* swap/upgrade: add the kit first, then remove the lines it replaces (never leaves the cart emptier on failure) */
  function swap(btn) {
    if (btn.classList.contains('shf-is-busy')) return;
    var id = +btn.getAttribute('data-shf-sb-swap');
    var keys = (btn.getAttribute('data-remove') || '').split(',').filter(Boolean);
    btn.classList.add('shf-is-busy');
    post('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function () {
        if (!keys.length) return null;
        var updates = {};
        keys.forEach(function (k) { updates[k] = 0; });
        return post('cart/update.js', { updates: updates });
      })
      .then(function () {
        track('shf_bundle_swap', { type: btn.getAttribute('data-shf-evt') || 'swap' });
        return refreshCart();
      })
      .catch(function () { location.href = root + 'cart'; });
  }

  function fbtUpdate(box) {
    if (!box) return;
    var on = box.querySelectorAll('[data-fbt-item]:checked');
    var sum = 0, elig = true;
    [].forEach.call(on, function (i) {
      sum += +i.getAttribute('data-price') || 0;
      if (i.getAttribute('data-elig') !== '1') elig = false;
    });
    var total = box.querySelector('[data-fbt-total]');
    var n = box.querySelector('[data-fbt-n]');
    var btn = box.querySelector('[data-fbt-add]');
    var tier = box.querySelector('[data-fbt-tier]');
    var pct = box.querySelector('[data-fbt-pct]');
    var after = box.querySelector('[data-fbt-after]');
    if (total) total.textContent = fmt(sum);
    if (n) {
      n.textContent = on.length;
      if (n.nextSibling) n.nextSibling.textContent = on.length === 1 ? ' מוצר לעגלה' : ' מוצרים לעגלה';
    }
    if (btn) btn.disabled = on.length < 1;
    if (tier) {
      tier.hidden = !(elig && on.length >= 2);
      if (pct) pct.textContent = on.length >= 3 ? '15%' : '10%';
      if (after) after.textContent = fmt(Math.floor(sum * (on.length >= 3 ? 85 : 90) / 100));
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-shf-rt]');
    if (t) {
      var w = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg');
      if (w) {
        e.preventDefault();
        w.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        track('shf_reviews_jump', {});
      }
      return;
    }
    var a = e.target.closest && e.target.closest('[data-shf-add-variant]');
    if (a) { e.preventDefault(); addItems(a, [{ id: +a.getAttribute('data-shf-add-variant'), quantity: 1 }]); return; }
    var s = e.target.closest && e.target.closest('[data-shf-sb-swap]');
    if (s) { e.preventDefault(); swap(s); return; }
    var f = e.target.closest && e.target.closest('[data-fbt-add]');
    if (f) {
      e.preventDefault();
      var box = f.closest('[data-shf-fbt]');
      var items = [].map.call(box.querySelectorAll('[data-fbt-item]:checked'), function (i) { return { id: +i.value, quantity: 1 }; });
      addItems(f, items);
    }
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('[data-fbt-item]');
    if (i) fbtUpdate(i.closest('[data-shf-fbt]'));
  });
})();